import { render, staticRenderFns } from "./CustomCursorSvg.vue?vue&type=template&id=62881867"
import script from "./CustomCursorSvg.vue?vue&type=script&lang=js"
export * from "./CustomCursorSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports